import { isVisible } from './visibility';

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

/**
 * Checks if a breakpoint is currently visible on the page, by checking if an element is visible with class `device-[breakpoint]`.
 * 
 * @notes
 * This function expects the following elements on the page (example based on Bootstrap):
 * <div class="device-xs d-block d-sm-none"></div>
 * <div class="device-sm d-none d-sm-block d-md-none"></div>
 * <div class="device-md d-none d-md-block d-lg-none"></div>
 * <div class="device-lg d-none d-lg-block d-xl-none"></div>
 * <div class="device-xl d-none d-xl-block"></div>
 * 
 * @param alias     The breakpoint to check.
 * 
 * @returns         True if the given breakpoint is visible, false otherwise.
 */
export function isBreakpoint(alias: Breakpoint): boolean {
  const selector = `.device-${alias}`;
  const isBreakpointVisible = isVisible(selector);

  return isBreakpointVisible;
}
